<template>

<NavBar></NavBar>
<!--  <SideBar></SideBar>-->
  <Login v-if="token == null"></Login>
  <Categoria v-if="sideOption == 'categoria' && token != null"></Categoria>
  <Contacto v-if="sideOption == 'contacto' && token != null"></Contacto>
  <Noticia v-if="sideOption == 'noticia' && token != null"></Noticia>
  <Producto v-if="sideOption == 'producto' && token != null"></Producto>
  <Usuario v-if="sideOption == 'usuario' && token != null"></Usuario>
</template>

<script>
import NavBar from "@/components/NavBar";
import SideBar from "@/components/SideBar";
import Login from "@/components/Login";
import Categoria from "@/components/Categoria";
import Contacto from "@/components/Contacto";
import Noticia from "@/components/Noticia";
import Producto from "@/components/Producto";
import Usuario from "@/components/Usuario";

import {computed, onBeforeMount, onMounted, ref} from "vue";
import {useStore} from "vuex";

export default {
  name: 'App',
  components: {
    NavBar, SideBar, Login, Categoria, Contacto, Noticia, Producto, Usuario
  },
  setup(){
    const store = useStore();
    let token = computed(() => store.state.userStore.token);
    let sideOption = computed(() => store.state.sideOption.option)


    store.dispatch("userStore/leerToken")





  return {
    token, sideOption
  }


  }
}
</script>














<style>
body {
  background-color: rgb(57, 62, 72);
}
</style>
